import React from "react";
import {SelectField} from "./FilterComponentStyles";
import {courierRequestStatuses} from "constants/constants";

const CourierRequestStatusFilter = ({
    value,
    onChange,
    showLabel = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false,
    ...props
}) => {
    return (
        <React.Fragment>
            {showLabel && <h5>{"Kurye Talebi Durumu"}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="courier_request_status"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
                {...props}
            >
                {courierRequestStatuses.map(status => (
                    <SelectField.Option
                        data-testid="courier_request_status_option"
                        value={status.value}
                    >
                        {status.name}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default CourierRequestStatusFilter;
